import { type IDropdownItem } from 'shared/ui'
import type { GroupInbox } from 'entities/Inbox/model/GroupInbox'
import type { ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu'

const typeRename = 'rename'

type IActionRename = {
  inbox: GroupInbox
  item: IDropdownItem
}

export const menuRename = (): IDropdownItem => {
  return {
    id: typeRename,
    iconL: 'edit',
    label: 'Rename',
  }
}

export const actionRename = ({ inbox, item }: IActionRename, store: ConversationMenuStore) => {
  if (item.id === typeRename) {
    store.sharedApiMenuStore.onRename(inbox)
  }
}
